import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';

import { I18nMapperService } from './i18n-mapper.service';
import { LoggingService } from '../logging/logging.service';
import { GridFilterPaging } from '@circlon/operate-api-model';
import { I18nListService } from '../gridfilter/i18n-list.service';

@Injectable()
export class I18nDataService {
  constructor(private i18nListService: I18nListService, private logger: LoggingService, private i18nMapperService: I18nMapperService) {}

  getTranslations(lang: string, group: string): Promise<any> {
    return lastValueFrom(
      this.i18nListService.requestList({
        gridFilterPaging: new GridFilterPaging(),
        orderBy: [],
        filter: {
          and: [
            {
              equals: {
                Group: group,
              },
            },
            {
              equals: {
                'Language.Code': lang,
              },
            },
          ],
        },
      })
    ).then(res => this.i18nMapperService.listToDictionary(res.result!));
  }

  getTranslations$(lang: string, group: string): Observable<any> {
    return this.i18nListService
      .requestList({
        gridFilterPaging: new GridFilterPaging(),
        orderBy: [],
        filter: {
          and: [
            {
              equals: {
                Group: group,
              },
            },
            {
              equals: {
                'Language.Code': lang,
              },
            },
          ],
        },
      })
      .pipe(map(res => this.i18nMapperService.listToDictionary(res.result!)));
  }
}
